import { createStore, Store } from "vuex"
import VuexPersistence from "vuex-persist"
import charts from "./modules/charts"
import encounters from "./modules/encounters"
import labOrders from "./modules/lab-orders"
import me from "./modules/me"
import occupationalHealthRecords from "./modules/occupational-health-records"
import providerRoles from "./modules/provider-roles"
import sidebar from "./modules/sidebar"
import stagedRxOrders from "./modules/staged-rx-orders"
import subordinateProviders from "./modules/subordinate_providers"

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store: Store<any> = createStore({
  plugins: [vuexLocal.plugin],
  modules: {
    me,
    charts,
    encounters,
    sidebar,
    labOrders,
    occupationalHealthRecords,
    subordinateProviders,
    stagedRxOrders,
    providerRoles
  }
})

//* Used to keep storage in sync between tabs
// window.addEventListener("storage", (e) => {
//   if (e.key !== vuexLocal.key) return
//   vuexLocal.restoreState(vuexLocal.key, vuexLocal.storage)
// })

export default store
export const useStore = (): Store<any> => store
